import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const reactionUpdateActionRoute: SiteHomePageRoute = createSiteRoute(
	createActionRoute({
		exact: true,
		name: 'reactionAction',
		path: '/update/:id/reaction',
	}),
);
